import useBusinessManagerScheduler from './useBusinessManagerScheduler';

export default useBusinessManagerScheduler;
